import React from 'react';
import { useTheme } from '../../context/ThemeContext';

interface VerificationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
  lastNameInput: string;
  setLastNameInput: (value: string) => void;
  loading: boolean;
}

const VerificationModal: React.FC<VerificationModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  lastNameInput,
  setLastNameInput,
  loading
}) => {
  const { theme } = useTheme();
  
  if (!isOpen) return null;
  
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 modal-backdrop p-4">
      <div className="bg-white p-4 sm:p-6 rounded-lg shadow-lg w-[95%] max-w-md mx-auto modal-content">
        <h2 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4">Verify Your Information</h2>
        <p className="mb-4 sm:mb-6 text-gray-600 text-sm sm:text-base">Please enter your last name to verify your identity and access your payment details.</p>
        
        <div className="mb-4 sm:mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-1 sm:mb-2">Last Name</label>
          <input
            type="text"
            value={lastNameInput}
            onChange={(e) => setLastNameInput(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base"
            placeholder="Enter your last name"
            disabled={loading}
            autoFocus
          />
        </div>
        
        <div className="flex flex-col sm:flex-row justify-end gap-2 sm:gap-3">
          <button 
            onClick={onClose}
            className="w-full sm:w-auto px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-smooth text-sm sm:text-base"
            disabled={loading}
          >
            Cancel
          </button>
          <button 
            onClick={onSubmit}
            disabled={!lastNameInput.trim() || loading}
            className={`w-full sm:w-auto px-4 py-2 rounded-md text-white button-hover text-sm sm:text-base ${theme["button-bg"]} ${
              !lastNameInput.trim() || loading ? 'opacity-60 cursor-not-allowed' : ''
            }`}
          >
            {loading ? 'Verifying...' : 'Verify'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default VerificationModal; 